import { useEffect, useState } from 'react'
import Feather from '@sysunite/react-feather'
import { Row, Col, Tooltip, Button } from 'antd'
import './GraphLayout.scss'

const GraphLayout = ({ onSetHierarchical = () => undefined }) => {
  const directions = {
    UD: { title: 'Up-Down', icon: 'arrow-down' },
    DU: { title: 'Down-Up', icon: 'arrow-up' },
    RL: { title: 'Right-Left', icon: 'arrow-left' },
    LR: { title: 'Left-Right', icon: 'arrow-right' }
  }

  const [active, setActive] = useState(false)
  const [direction, setDirection] = useState('UD')
  const [tooltipVisible, setTooltipVisible] = useState(false)

  let classNames = ['graph-layout']

  active && classNames.push('is-open')

  useEffect(() => {
    if (active) {
      onSetHierarchical({
        direction,
        sortMethod: 'directed',
        nodeSpacing: 150
      })
    } else {
      onSetHierarchical(active)
    }
  }
  , [active, direction])

  return (
    <div className={classNames.join(' ')}>
      <Row>
        <Col>
          <Tooltip
            placement="bottomLeft"
            trigger="hover"
            mouseEnterDelay={1}
            visible={!active && tooltipVisible}
            onVisibleChange={setTooltipVisible}
            title="Set hierarchical layout"
            >
              <Button
                onClick={() => setActive(!active)}
                className={active && 'active'}
                type="link"
                icon={<Feather size="1.5em" style={{ transform: 'rotate(90deg)' }} type="share-2" />}
              />
          </Tooltip>
        </Col>
        {
          active &&
            <Col className="layouts" flex>
              {
                _.map(directions, ({ title, icon }, key) =>
                  <Tooltip
                    placement="bottomLeft"
                    trigger="hover"
                    mouseEnterDelay={1}
                    key={key}
                    title={title}>
                    <Button
                      onClick={() => setDirection(key)}
                      className={direction === key && 'active' }
                      type="link"
                      icon={<Feather size="1.5em" type={icon} />} />
                  </Tooltip>
                )
              }
            </Col>
        }
      </Row>
    </div>
  )
}

export default GraphLayout
